import { render } from "./FeaturedBrands.vue?vue&type=template&id=6a12c1bf&scoped=true"
import script from "./FeaturedBrands.vue?vue&type=script&lang=js"
export * from "./FeaturedBrands.vue?vue&type=script&lang=js"

import "./FeaturedBrands.vue?vue&type=style&index=0&id=6a12c1bf&lang=scss&scoped=true"

import exportComponent from "/Users/flegate/Serveur/Sites/welcom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a12c1bf"]])

export default __exports__